import * as v from 'valibot';

import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';

import { faArrowsRepeat } from '@fortawesome/pro-duotone-svg-icons';

import { useNewClaimMutate } from '@repo/api/claim/claims';

import { Route as NewRoute } from '~pages/_claims/claim.$claimId/(fnol)/create.$page';
import {
	Route as ClaimsHome,
	Filters as ClaimsHomeFilters,
} from '~pages/_claims/claims';
import {
	Route as RisksHome,
	Filters as RisksHomeFilters,
} from '~pages/_risks/risks';
import { Page } from './-components/Page';
import { readHomeSearchSnapshot } from './-context/homeSearchStorage';

export const Route = createFileRoute('/_claims')({
	component: function Claims() {
		const { mutate: mutateNewClaim, isPending: newClaimLoading } =
			useNewClaimMutate();

		const navigate = useNavigate();
		const navigateToClaimsHome = () => {
			const search = readHomeSearchSnapshot('claims', (value) =>
				v.parse(ClaimsHomeFilters, value),
			);

			void navigate({
				to: ClaimsHome.to,
				...(search === undefined ? {} : { search }),
			});
		};
		const navigateToRisksHome = () => {
			const search = readHomeSearchSnapshot('risks', (value) =>
				v.parse(RisksHomeFilters, value),
			);

			void navigate({
				to: RisksHome.to,
				...(search === undefined ? {} : { search }),
			});
		};

		return (
			<Page
				home={{
					link: ClaimsHome,
					label: 'Claims',
					onNavigate: navigateToClaimsHome,
				}}
				adminActions={[
					{
						name: 'Switch to Underwriting',
						icon: faArrowsRepeat,
						route: { to: RisksHome.to },
						permission: 'risk',
						onSelect: navigateToRisksHome,
					},
				]}
				createButton={{
					permission: 'home.claim.create',
					label: 'Create New Claim',
					action: () => {
						mutateNewClaim(undefined, {
							onSuccess: (data) => {
								void navigate({
									to: NewRoute.to,
									params: { claimId: `${data.claimId}`, page: 'insured' },
								});
							},
						});
					},
					loading: newClaimLoading,
				}}
				help={[
					{
						label: 'Reassign Claims',
						name: 'ReassignClaim',
						message:
							'Need help? Watch this short video guide showing you how to reassign claims',
					},
					{
						label: 'Manual Intervention',
						name: 'ManualIntervention',
						message:
							'Need help? Watch this quick video guide to walk you through the manual intervention process',
					},
				]}
			>
				<Outlet />
			</Page>
		);
	},
});
